import { render } from "./App.vue?vue&type=template&id=f7c544ec"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f7c544ec&lang=css"
script.render = render

export default script